import React from 'react';

import Cavitypet from './Cavitypet';
import Kpetseries from './Kpetseries';
import Ordinarypet from './Ordinarypet';
import Moldcavity from './Moldcavity';


const Cavitypetprefor = () => {
    return (
        <div>
            <Cavitypet />
            <Kpetseries />
            <Ordinarypet />
            <Moldcavity />
        </div>
    );
};

export default Cavitypetprefor;
